@if (isLoading()) {
  <lib-loader/>
} @else {
  <lib-variance-chart
    [varianceData]="chartData()"
    [valueFormatter]="mainFormatter()"
    [isAligned]="measure()?.alignment !== Alignment.Opposite"
  />
}
